import { Component, OnDestroy, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from './../../../../@fuse/services/config.service';
import { navigation } from './../../../navigation/navigation';

@Component({
    selector     : 'vertical-layout-3',
    templateUrl  : './layout-3.component.html',
    styleUrls    : ['./layout-3.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VerticalLayout3Component implements OnInit, OnDestroy
{
    fuseConfig: any;
    navigation: any;

    hasDynamicToolbar: boolean = false;
    hasDynamicQuickPanel: boolean = false;
    hasDynamicNavBarConfig: boolean = false;
    hasDynamicFooter: boolean = false;
    @Input() toolbarComponent : any;
    @Input() quickPanelComponent: any;
    @Input() userInfo: any;
    @Input() footerComponent: any;
    @Input() sidePanelComponent: any;

    // Private
    private _unsubscribeAll: Subject<void>;

    /**
     * Constructor
     *
     * param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private _fuseConfigService: FuseConfigService
    )
    {
        // Set the defaults
        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
            });

        this.hasDynamicToolbar = this.toolbarComponent ? true : false;
        this.hasDynamicQuickPanel = this.quickPanelComponent ? true : false;
        this.hasDynamicFooter =  this.footerComponent ? true : false;
        //this.hasDynamicNavBarConfig = this.sideNavBarConfig ? true : false;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }
}
